
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import { IUserData } from '@/types/user-types'
import { UserService } from '@/services'
import UpdateMemo from './memo.vue'
import { UserModule } from '@/store/modules/user'

enum role {
    super = 2
}

/**
 * 
 * @prop users      用户列表数据
 * @prop type       展示类型
 * 
*/
@Component({
    name: 'UserTable',
    components: {
        UpdateMemo
    }
})
export default class extends Vue {
    @Prop({ required: true }) private users!: IUserData[]
    @Prop({ default: 'list' }) private type!: String
    @Ref('memoDialogRef') private memoDialog!: any

    private mapIdentities: any = {
        0: '媒体人',
        1: '品牌方/政务人士',
        2: '专家学者',
        3: '线人/其他'
    }
    private mapCertStatus: any = {
        0: '未认证',
        1: '申请认证中',
        2: '认证成功',
        3: '认证失败'
    }
    private mapPlatform: any = {
        1: 'PC',
        2: 'H5',
        3: 'APP',
        4: '微信小程序'
    }

    private curMemo = ''
    private curUser: any = ''

    private get isSuper() {
        return UserModule.role === role.super
    }

    // 修改联系状态
    private async onUpdateInfo(user:any, value: any) {
        const params = {
            user_id: user.id,
            is_contacted: value.status,
            memo: value.memo
        }
        const result = await UserService.updateNmUser(params)
        this.memoDialog.close()
        if (result.status === 200) {
            if (value.status != null) {
                user.is_contacted = value.status    
            } else {
                user.memo = params.memo
            }
            return this.$message.success('修改成功')
        }
        return this.$message.error('修改失败')
    }

    private onUpdateMemo(memo: string) {
        this.onUpdateInfo(this.curUser, memo)
    }

    private onEditMemo(row: any) {
        this.curUser = row
        this.curMemo = row.memo
        this.memoDialog.show()
    }
}
